import { Button, OptionSheet } from '@relay-towing/ui';
import { SlidersHorizontal } from '@phosphor-icons/react';

/**
 * A list's Filters button, in its toolbar beside the magnifier as the
 * Figma's Functions screens draw it (3-65), opening how the list is sorted.
 * Sort sat in the page's header before, apart from the search and the
 * view it changes.
 */
export function SortFilters<Sort extends string>({
  options,
  value,
  onValueChange,
}: {
  options: Array<{ value: Sort; label: string }>;
  value: Sort;
  onValueChange: (value: Sort) => void;
}) {
  return (
    <OptionSheet
      title="Sort"
      options={options}
      value={value}
      onValueChange={(next) => onValueChange(next as Sort)}
      trigger={
        <Button variant="ghost" size="lg" leadingIcon={<SlidersHorizontal />}>
          Filters
        </Button>
      }
    />
  );
}
